/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  successDefault: {
    id: 'useElasticDraft.successDefault',
    defaultMessage:
      'I searched my knowledge base and found this information which might be useful'
  },
  noResultsDefault: {
    id: 'useElasticDraft.noResultsDefault',
    defaultMessage:
      'I searched my knowledge base, but did not find anything related to your query'
  },
  connectivityIssueDefault: {
    id: 'useElasticDraft.connectivityIssueDefault',
    defaultMessage:
      'I might have information related to your query to share, but am unable to connect to my knowledge base at the moment'
  },
  citationsTitleDefault: {
    id: 'useElasticDraft.citationsTitleDefault',
    defaultMessage: 'How do we know?'
  }
});
